import { atom } from 'jotai';

const isLoginSidebarOpenAtom = atom(false);

export default isLoginSidebarOpenAtom;
